import { Logger } from '@opentelemetry/api-logs';
import { PayloadAction } from '../../types';
import { SET_TELEMETRY_LOGGER } from '../../constants/actionConstants';

export const telemetryLogger = (
  state: any = null,
  action: PayloadAction<Logger, 'SET_TELEMETRY_LOGGER'>,
): any => {
  switch (action.type) {
    case SET_TELEMETRY_LOGGER:
      return action.payload ?? state;
    default:
      return state;
  }
};
